import React from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';

import './ErrorBox.css';
import { IconLoader } from 'common/IconLoader';

/* Props:
    message - the content of the ErrorBox message 
    close   - function to run when x is clicked
*/
export const ErrorBox = (props) => {
  return (
    <div className="ErrorBox">
      <div className="ErrorBox_InnerDiv">
        <div className="ErrorBox_Title">Error </div>
        {props.message}
      </div>
      {props.close ? (
        <div className="ErrorBox_X_Div">
          <SvgAF
            img={IconLoader.icon_x}
            hover={IconLoader.icon_x_hover}
            onClick={() => {
              props.close();
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

